import { useAppSelector } from '../../../store/hooks/Redux'
import { selectUser } from '../../../store/reducers/AuthSlice'

/** Вход под другим пользователем доступен только админам и в режиме имперсонации */
export const useImpersonateAvailable = () => {
  const user = useAppSelector(selectUser)

  return user.role === 'admin' || !!user.is_virtual_mode
}